/** Refactor routing ok  */
import { RouteName } from "../RouteNames";

export const amendmentsRoutes = {
  name: RouteName.AmendementsRoot,
  path: "amendments",
  redirect: () => ({ name: RouteName.Amendements }),
  children: [
    {
      name: RouteName.Amendements,
      path: "",
      component: () =>
        import("@follaw-fr/views/side_menu_views/AmendmentsView.vue"),
    },
    {
      name: RouteName.AmendementsFollawed,
      path: "follawed",
      component: () =>
        import("@follaw-fr/views/side_menu_views/AmendmentsView.vue"),
    },
    {
      name: RouteName.AmendementsZoom,
      path: ":id",
      component: () =>
        import("@follaw-fr/views/side_menu_views/AmendmentsZoomView.vue"),
    },
  ],
};
